import { CreateView } from "./CreateView";

export default CreateView;
